<template>
    <div class="container-fluid">
        <Speaker @toggleSpeaking="getSpeaker"></Speaker>

        <section class="container-fluid">
            <h1 class="titles">Documento en progreso</h1>
            <h3 class="subtitles" v-if="pdf_name">{{ pdf_name }}.pdf</h3>
        </section>
        <section class="container-fluid">
            <b-overlay :show="finishLoading" rounded="sm" :opacity="0.5">
                <b-row>
                    <b-col xl="9">
                        <div class="pg_number">
                            {{page}}/{{ numPages }}
                        </div>
                        <div class="viewer">
                            <div class="arrow left">
                                <b-icon icon="arrow-left-circle" font-scale="2" aria-hidden="true"
                                    @click="page > 1 ? page-- : 1"></b-icon>
                            </div>
                            <div class="arrow right">
                                <b-icon icon="arrow-right-circle" font-scale="2" aria-hidden="true"
                                    @click="page < numPages ? page++ : 1"></b-icon>
                            </div>
                            <pdf :src="src" :page="page" class="pdf-self" @num-pages="numPages = $event"
                                @page-loaded="page = $event" @loaded="pdfLoaded" @progress="loadedRatio = $event"
                                @error="error">
                            </pdf>
                            <b-overlay :show="isLoading" opacity="0.5" blur="none" no-wrap>
                                <template v-slot:overlay>
                                    <div class="text-center">
                                        <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary" animation="spin"
                                            font-scale="3"></b-icon>
                                    </div>
                                </template>
                            </b-overlay>
                        </div>
                    </b-col>
                    <b-col xl="3" class="d-none d-xl-block p-0">
                        <b-overlay :show="docDetailsLoading" rounded="sm">
                            <b-container class="details-col px-2 py-4">
                                <b-overlay :show="reminderLoading" opacity="0" blur="none" no-wrap>
                                    <template v-slot:overlay>
                                        <div class="text-center">
                                            <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary"
                                                animation="spin" font-scale="3"></b-icon>
                                            Cargando datos...
                                        </div>
                                    </template>
                                </b-overlay>
                                <h6 :class="{ titleUnderline: true }">Detalles del documento
                                </h6>
                                <div class="mt-3 mb-2">
                                    <b-icon-file-earmark-text font-scale="1.3"
                                        variant="secondary"></b-icon-file-earmark-text>
                                    <span class="ml-2 details-subtitle" v-if="pdf_name">{{ pdf_name }}.pdf</span>
                                </div>
                                <div class="mt-2 mb-1">
                                    <span class="info-t">Creado el:</span>
                                    <div class="info-d" v-if="pdf_created">
                                        {{ new Date(pdf_created) | date('dd/MM/yyyy') }}
                                    </div>
                                </div>
                                <div class="mt-2 mb-1">
                                    <span class="info-t">Estado:</span>
                                    <div class="info-d" v-if="pdf_created">
                                        {{ state }}
                                    </div>
                                </div>
                                <div class="mt-2 mb-1" v-if="show_hash">
                                    <span class="info-t">Hash:</span>
                                    <div class="info-d"> {{ hash }}</div>
                                </div>

                                <div
                                    v-if="senders[0] != null && (this.notifications === true || state === 'Rechazado')">
                                    <h6 class="titleUnderline mt-5">Destinatario </h6>
                                    <div v-for="(send, index) in senders" :key="index" class="mb-2">
                                        <div class="text-center">
                                            <div style="font-size: 2rem;">
                                                <b-icon-bell id="reminder" aria-hidden="true"
                                                    v-if="(send.State != 'Completado' && send.State != 'Rechazado') && (send.SendTo != email)"
                                                    @click="sendReminder(index)" class="action-details-btn mr-3"
                                                    scale="0.6"></b-icon-bell>
                                            </div>
                                            <b-tooltip target="reminder" variant="danger"
                                                title="Enviar recordatorio"></b-tooltip>
                                        </div>
                                        <div class="mt-1 mb-1">
                                            <span class="info-t">Nombre:</span>
                                            <div class="info-d">{{ send.Name }}</div>
                                        </div>
                                        <div class="mt-1 mb-1">
                                            <span class="info-t">Correo:</span>
                                            <div class="info-d">{{ send.SendTo }}</div>
                                        </div>
                                        <div class="mt-1 mb-1">
                                            <span class="info-t">Estado:</span>
                                            <div class="info-d">{{ send.State }}</div>
                                            <div v-if="send.State == 'Rechazado'">
                                                <span class="subtitle ml-2">Motivo Rechazo:</span>
                                                <div class="info-box-rounded doc-info mb-2">
                                                    <div class="info-box-rounded-content">
                                                        <span class="doc-info-subtitle"> {{ send.RejectedDetails
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h6 class="titleUnderline mt-5">Evidencias</h6>
                                <select
                                    class="mt-2 pl-3 custom-select custom-select-sm input-rounded w-100 ml-0 doc-info"
                                    v-model="selected_signed_user" @change="getEvidencias($event.target.value)">
                                    <option :value="null">usuario</option>
                                    <option v-for="(item, index) in pendingSenders" :key="index" :value="item.SendTo">{{
                                        item.Name }}
                                    </option>
                                </select>
                                <b-overlay :show="evidenceLoading" rounded="sm" :opacity="0.5">
                                    <div v-if="selected_signed_user != null">
                                        <form-wizard step-size="sm" color="#2E344A" subtitle="" title="">
                                            <tab-content title="Envío del documento">
                                                <div class="mb-1">
                                                    <span class="subtitle ml-2">Usuario:</span>
                                                    <div class="info-box-rounded doc-info mb-2">
                                                        <div class="info-box-rounded-content">
                                                            <span class="doc-info-subtitle" v-if="userSent">
                                                                {{ userSent }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mt-3 mb-1">
                                                    <span class="subtitle ml-2">Fecha de envío:</span>
                                                    <div class="info-box-rounded doc-info mb-2">
                                                        <div class="info-box-rounded-content">
                                                            <span class="doc-info-subtitle" v-if="sentDate"> {{
                                                                new
                                                                Date(sentDate) | date('dd/MM/yyyy hh:mm a')
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </tab-content>
                                            <tab-content title="Recepción del documento">
                                                <div class="mb-1">
                                                    <span class="subtitle ml-2">Usuario:</span>
                                                    <div class="info-box-rounded doc-info mb-2">
                                                        <div class="info-box-rounded-content">
                                                            <span class="doc-info-subtitle"> {{ userSign
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mt-3 mb-1">
                                                    <span class="subtitle ml-2">Email:</span>
                                                    <div class="info-box-rounded doc-info mb-2">
                                                        <div class="info-box-rounded-content">
                                                            <span class="doc-info-subtitle"> {{ userEmailSign
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mt-3 mb-1">
                                                    <span class="subtitle ml-2">Fecha de recepción:</span>
                                                    <div class="info-box-rounded doc-info mb-2">
                                                        <div class="info-box-rounded-content">
                                                            <span class="doc-info-subtitle"> {{ new
                                                                Date(dateReception)
                                                                | date('dd/MM/yyyy hh:mm a') }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </tab-content>
                                            <tab-content title="Firma del documento">
                                                <div class="mb-1">
                                                    <span class="subtitle ml-2">Usuario:</span>
                                                    <div class="info-box-rounded doc-info mb-2">
                                                        <div class="info-box-rounded-content">
                                                            <span class="doc-info-subtitle"> {{ userSign
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mt-3 mb-1">
                                                    <span class="subtitle ml-2">Fecha de firma:</span>
                                                    <div class="info-box-rounded doc-info mb-2">
                                                        <div class="info-box-rounded-content">
                                                            <span class="doc-info-subtitle"> {{ signDate
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <b-row v-show="user_captured.length" class="mt-4">
                                                    <b-col v-for="(user_image, index) in user_captured" :key="index">
                                                        <b-img thumbnail fluid :src="user_image"
                                                            alt="Image Captured ${index}"></b-img>
                                                    </b-col>
                                                </b-row>
                                            </tab-content>
                                            <button slot="prev" class="wizard-circle-btn ml-1">
                                                <b-icon-arrow-left-short aria-hidden="true"
                                                    scale="1.5"></b-icon-arrow-left-short>
                                            </button>
                                            <button slot="next" class="wizard-circle-btn mr-1">
                                                <b-icon-arrow-right-short aria-hidden="true"
                                                    scale="1.5"></b-icon-arrow-right-short>
                                            </button>
                                            <button slot="finish" class="d-none"></button>
                                        </form-wizard>
                                    </div>
                                    <template v-slot:overlay>
                                        <div class="text-center">
                                            <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary"
                                                animation="spin" font-scale="3"></b-icon>
                                        </div>
                                    </template>
                                </b-overlay>
                                <hr class="my-1" />
                                <b-container>
                                    <b-row class="justify-content-center">
                                        <b-col xl="8" class="text-center mt-2">
                                            <div style="font-size: 2rem;">
                                                <b-icon-arrow-left id="back" aria-hidden="true"
                                                    class="action-details-btn" scale="0.6"
                                                    @click="backToList"></b-icon-arrow-left>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </b-container>
                            <template v-slot:overlay>
                                <div class="text-center">
                                    <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary" animation="spin"
                                        font-scale="3"></b-icon>
                                </div>
                            </template>
                        </b-overlay>
                    </b-col>
                </b-row>
                <template v-slot:overlay>
                    <div class="text-center">
                        <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary" animation="spin"
                            font-scale="3"></b-icon>
                        <p id="cancel-label">Por favor espere...</p>
                    </div>
                </template>
            </b-overlay>
        </section>
        <b-sidebar id="sidebar-details" title="" right bg-variant="white" backdrop shadow class="d-xl-none">
            <template #footer>
                <hr class="my-1 mx-3" />
                <b-row class="justify-content-center">
                    <b-col xl="8" class="text-center mt-2 pb-3">
                        <div style="font-size: 2rem;">
                            <b-icon-arrow-left id="back" aria-hidden="true" class="action-details-btn" scale="0.6"
                                @click="backToList"></b-icon-arrow-left>
                        </div>
                    </b-col>
                </b-row>
            </template>
            <div class="px-3 mb-4">
                <h6 :class="{ titleUnderline: true }">Detalles del documento
                </h6>
                <div class="mt-3 mb-2">
                    <b-icon-file-earmark-text font-scale="1.3" variant="secondary"></b-icon-file-earmark-text>
                    <span class="ml-2 details-subtitle" v-if="pdf_name">{{ pdf_name }}.pdf</span>
                </div>
                <div class="mt-3 mb-1">
                    <span class="info-t">Creado el:</span>
                    <div class="info-d" v-if="pdf_created">
                        {{ new Date(pdf_created) | date('dd/MM/yyyy') }}
                    </div>
                </div>
                <div class="mt-3 mb-1">
                    <span class="info-t">Estado:</span>
                    <div class="info-d" v-if="pdf_created">
                        {{ state }}
                    </div>
                </div>
                <div class="mt-3 mb-1" v-if="show_hash">
                    <span class="info-t">Hash:</span>
                    <div class="info-d"> {{ hash }}</div>
                </div>

                <div v-if="senders[0] != null && (this.notifications === true || state === 'Rechazado')">
                    <h6 class="titleUnderline mt-5">Destinatario </h6>
                    <div v-for="(send, index) in senders" :key="index" class="mb-2">
                        <div class="text-center">
                            <div style="font-size: 2rem;">
                                <b-icon-bell id="reminder" aria-hidden="true"
                                    v-if="(send.State != 'Completado' && send.State != 'Rechazado') && (send.SendTo != email)"
                                    @click="sendReminder(index)" class="action-details-btn mr-3"
                                    scale="0.6"></b-icon-bell>                                
                            </div>
                            <b-tooltip target="reminder" variant="danger" title="Enviar recordatorio"></b-tooltip>
                        </div>
                        <div class="mt-3 mb-1">
                            <span class="info-t">Nombre:</span>
                            <div class="info-d">{{ send.Name }}</div>
                        </div>
                        <div class="mt-3 mb-1">
                            <span class="info-t">Correo:</span>
                            <div class="info-d">{{ send.SendTo }}</div>
                        </div>
                        <div class="mt-3 mb-1">
                            <span class="info-t">Estado:</span>
                            <div class="info-d">{{ send.State }}</div>
                            <div v-if="send.State == 'Rechazado'">
                                <span class="subtitle ml-2">Motivo Rechazo:</span>
                                <div class="info-box-rounded doc-info mb-2">
                                    <div class="info-box-rounded-content">
                                        <span class="doc-info-subtitle"> {{ send.RejectedDetails
                                            }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h6 class="titleUnderline mt-5">Evidencias</h6>
                <select class="mt-3 pl-3 custom-select custom-select-sm input-rounded w-100 ml-0 doc-info"
                    v-model="selected_signed_user" @change="getEvidencias($event.target.value)">
                    <option :value="null">usuario</option>
                    <option v-for="(item, index) in pendingSenders" :key="index" :value="item.SendTo">{{ item.Name }}
                    </option>
                </select>
                <b-overlay :show="evidenceLoading" rounded="sm" :opacity="0.5">
                    <div v-if="selected_signed_user != null">
                        <form-wizard step-size="sm" color="#2E344A" subtitle="" title="">
                            <tab-content title="Envío del documento">
                                <div class="mb-1">
                                    <span class="subtitle ml-2">Usuario:</span>
                                    <div class="info-box-rounded doc-info mb-2">
                                        <div class="info-box-rounded-content">
                                            <span class="doc-info-subtitle" v-if="userSent">
                                                {{ userSent }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3 mb-1">
                                    <span class="subtitle ml-2">Fecha de envío:</span>
                                    <div class="info-box-rounded doc-info mb-2">
                                        <div class="info-box-rounded-content">
                                            <span class="doc-info-subtitle" v-if="sentDate"> {{
            new
                Date(sentDate) | date('dd/MM/yyyy hh:mm a')
        }}</span>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>
                            <tab-content title="Recepción del documento">
                                <div class="mb-1">
                                    <span class="subtitle ml-2">Usuario:</span>
                                    <div class="info-box-rounded doc-info mb-2">
                                        <div class="info-box-rounded-content">
                                            <span class="doc-info-subtitle"> {{ userSign
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3 mb-1">
                                    <span class="subtitle ml-2">Email:</span>
                                    <div class="info-box-rounded doc-info mb-2">
                                        <div class="info-box-rounded-content">
                                            <span class="doc-info-subtitle"> {{ userEmailSign
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3 mb-1">
                                    <span class="subtitle ml-2">Fecha de recepción:</span>
                                    <div class="info-box-rounded doc-info mb-2">
                                        <div class="info-box-rounded-content">
                                            <span class="doc-info-subtitle"> {{ new
                                                Date(dateReception)
                                                | date('dd/MM/yyyy hh:mm a') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>
                            <tab-content title="Firma del documento">
                                <div class="mb-1">
                                    <span class="subtitle ml-2">Usuario:</span>
                                    <div class="info-box-rounded doc-info mb-2">
                                        <div class="info-box-rounded-content">
                                            <span class="doc-info-subtitle"> {{ userSign
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3 mb-1">
                                    <span class="subtitle ml-2">Fecha de firma:</span>
                                    <div class="info-box-rounded doc-info mb-2">
                                        <div class="info-box-rounded-content">
                                            <span class="doc-info-subtitle"> {{ signDate
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                                <b-row v-show="user_captured.length" class="mt-4">
                                    <b-col v-for="(user_image, index) in user_captured" :key="index">
                                        <b-img thumbnail fluid :src="user_image" alt="Image Captured ${index}"></b-img>
                                    </b-col>
                                </b-row>
                            </tab-content>
                            <button slot="prev" class="wizard-circle-btn ml-1">
                                <b-icon-arrow-left-short aria-hidden="true" scale="1.5"></b-icon-arrow-left-short>
                            </button>
                            <button slot="next" class="wizard-circle-btn mr-1">
                                <b-icon-arrow-right-short aria-hidden="true" scale="1.5"></b-icon-arrow-right-short>
                            </button>
                            <button slot="finish" class="d-none"></button>
                        </form-wizard>
                    </div>
                    <template v-slot:overlay>
                        <div class="text-center">
                            <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary" animation="spin"
                                font-scale="3"></b-icon>
                        </div>
                    </template>
                </b-overlay>
            </div>
        </b-sidebar>

    </div>
</template>

<script>
import axios from 'axios'
import pdf from 'vue-pdf'
//import * as faceapi from 'face-api.js'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { speakMessage } from '../voice/index.js'
import Speaker from '../voice/speaker.vue';
export default {
    name: 'viewerDoc',
    components: {
        pdf,
        FormWizard,
        TabContent,
        Speaker
    },
    data() {
        return {
            pagesSignatures: [],
            incrementalSignatureId: 0,
            signatureStyleObject: {
                opacity: 0.85,
            },
            userFileSignaturePositions: [],
            fillSignaturePositionsWithServerValues: false,
            allowSignatures: false,

            src: '',
            numPages: undefined,
            pdf_id: this.$route.params.id,
            pdf_name: null,
            signed: null,
            pdf_created: null,
            page: 0,
            publicPath: process.env.BASE_URL,
            img: null,
            signature_pad: undefined,
            hash: null,
            senders: [],
            pendingSenders: [],
            state: null,
            //sign details
            userSent: null,
            userSign: null,
            userEmailSign: null,
            sentDate: null,
            signDate: null,
            //show images captured
            user_captured: [],
            //get parameters
            name: null,
            email: null,
            security_id: null,
            width: 0,
            height: 0,
            pageWidth: 0,
            pageHeight: 0,
            x: 0,
            y: 0,
            image: false,
            isLoading: false,
            docDetailsLoading: true,
            folder_name: null,
            dateReception: null,
            reminderLoading: false,
            // Camera
            isPhotoTaken: false,
            image_captured: [],
            print: false,
            show_sign: false,
            sign_button: this.$store.getters.loggedIn,
            show_hash: false,
            current_email: this.$store.state.userEmail,
            evidenceLoading: false,
            finishLoading: false,
            userName: null,
            selected_signed_user: null,
            // Save Signature
            recipient_name: null,
            recipient_email: null,
            token: null,
            loadedRatio: 0,
            notifications: false,
            rejectDocumentDetails: '',
            allowSpeech: false,
        }
    },
    watch: {
        page() {
            this.watchRenderPage();
        },
        FirmarBtnText() {
            const firmarBtnText = this.getFirmarBtnText();

            if (firmarBtnText === 'Añadir') {
                this.signText = this.addsignText;
            } else if (firmarBtnText === 'Volver a firmar') {
                this.signText = this.againsignText;
            } else {
                this.signText = 'Utiliza esta opción para firmar y previsualizar la misma en el documento.';
            }
        }
    },
    created() {
        let self = this;
        self.src = pdf.createLoadingTask('/api/File/' + this.pdf_id);
    },
    async mounted() {
        if (this.$route.params.securityId) {
            localStorage.clear();
        }
        if (!this.$store.getters.loggedIn) {
            axios.get('/api/File/GetUserByFileId/' + this.pdf_id).then(response => {
                if (response.data.IsSuccessFul) {
                    this.userName = response.data.Result.Username;
                }
            });
        } else {
            this.userName = this.$store.state.userName
        }
        this.getFileDetail();
        this.getUserDateReception();

        let self = this;
        self.src.promise.then((pdf) => {

            this.numPages = pdf.numPages;
            this.isLoading = false;

            for (let i = 0; i < this.numPages; i++) {
                let data = {
                    pageNumber: i + 1,
                    pageWidth: 0,
                    pageHeight: 0,
                    signatures: [],
                    signaturesForShow: []
                };
                this.pagesSignatures.push(data);
            }


        });

        this.token = localStorage.getItem('access_token');

        await this.$store.dispatch("load");

        axios.get('/api/File/GetUserByFileId/' + this.pdf_id).then(response => {
            if (response.data.IsSuccessFul) {
                this.cedula = response.data.Result.Dni;
            }
        });
    },
    methods: {
        getUserDateReception() {
            let email = null;
            if (this.$store.getters.loggedIn) {
                email = this.current_email;
            } else {
                email = this.$route.params.email
            }
            if (localStorage.tab_title == "Pendiente" || this.$route.params.securityId != null) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
                axios.get('/api/File/UpdateDocDateReception/' + this.pdf_id + '/' + email).then(() => { });
            }
        },
        getFileDetail() {
            this.isLoading = true;
            if (this.$route.params.name && this.$route.params.name != "Multifirma") {
                this.name = this.$route.params.name;
            }
            if (this.$route.params.email) {
                this.email = this.$route.params.email;
            }
            if (this.$route.params.securityId) {
                this.sign_button = true;
                this.security_id = this.$route.params.securityId;
                this.$store.dispatch("destroyToken").then(() => { });
            }
            if (this.$store.getters.loggedIn) {
                this.email = this.current_email;
            }

            if (localStorage.tab_title == "En proceso" ||
                localStorage.tab_title == "Completado" ||
                !this.$store.getters.loggedIn && this.state == 'Completado') {
                this.sign_button = false;
                this.docDetailsLoading = false;
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
            axios.get('/api/File/GetFileById/' + this.pdf_id + '/' + this.name + '/' + this.email + '/' + this.security_id).then(response => {
                if (response.data.IsSuccessFul) {
                    this.docDetailsLoading = false;
                    this.pdf_name = response.data.Result.DocumentName;
                    this.folder_name = response.data.Result.FolderName;
                    this.signed = response.data.Result.Signed;
                    this.state = response.data.Result.State;
                    this.ask_data = response.data.Result.AskData;
                    this.pdf_created = response.data.Result.Created;
                    this.hash = response.data.Result.HashSignature;
                    this.senders = response.data.Result.EmailList;
                    this.pendingSenders = this.senders.filter(sender => {
                        return sender.State == "Completado";
                    })
                    this.notifications = response.data.Result.Notifications;
                    this.sign_button = response.data.Result.SignButton;
                    this.userFileSignaturePositions = response.data.Result.UserFileSignaturePositions;
                    this.fillSignaturePositionsWithServerValues = this.userFileSignaturePositions.length > 0;
                    this.SignatureOption = response.data.Result.SignatureOption;
                    this.VerifySignerOption = response.data.Result.verifySigner;
                    console.log(this.state)

                    if (this.state == "Pendiente" || this.state == "Progreso") {
                        this.$bvModal.show('document-pending-modal');
                    }

                    if (this.state == "Completado") {
                        this.show_hash = true;
                    }
                    if (this.signed || this.state === "Rechazado") {
                        this.sign_button = false;
                    }
                } else {
                    this.$bvToast.toast(`El acceso a este archivo no esta permitido, revise la url.`, {
                        title: 'Lo sentimos',
                        variant: 'danger'
                    });
                }
            });
        },
        printPdf() {
            let config = { responseType: 'blob' }
            this.print = true;
            axios.get('/api/File/GetFilePrint/' + this.pdf_id + '/' + this.print + '/' + this.email, config).then(response => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                this.$print(fileURL);
                this.print = false;
            });
        },
        downloadPdf() {
            window.open('/api/File/GetFilePrint/' + this.pdf_id + '/' + this.print + '/' + this.email);
        },
        sendReminder(index) {
            this.reminderLoading = true;
            axios.get('/api/File/SendNotification/' + this.pdf_id + '/' + this.senders[index].Name + '/' + this.senders[index].SendTo).then(response => {
                this.reminderLoading = false;
                if (response.data.IsSuccessFul) {
                    this.$bvToast.toast(`Ha enviado el correo de recordatorio de firma correctamente.`, {
                        title: 'Enhorabuena',
                        variant: 'info'
                    });
                }
            });
        },

        async onPlay() {
            console.log("playing");
        },
        async playAudio(message) {
            speakMessage(message, this.allowSpeech);
        },
        isCedula() {
            let pattern = /^(PE|E|N|[23456789](?:AV|PI)?|1[0123]?(?:AV|PI)?)-(\d{1,4})-(\d{1,7})$/i;
            return (this.cedula.match(pattern)) ? true : false;
        },
        getEvidencias(selected) {
            if (selected === "") {
                this.evidenceLoading = false;
                return;
            }
            this.evidenceLoading = true;
            this.userEmailSign = selected;
            axios.get('/api/File/GetSignatureDetail/' + this.pdf_id + '/' + selected).then(response => {
                this.userSent = response.data.Result.UserSent;
                this.userSign = response.data.Result.UserSign;
                this.sentDate = response.data.Result.DateSent;
                this.signDate = (response.data.Result.DateSign !== '0001-01-01T00:00:00')
                    ? this.formatDate(response.data.Result.DateSign)
                    : "No firmado";
                this.user_captured = response.data.Result.ClientImage;
                this.dateReception = response.data.Result.DateReception;
                this.evidenceLoading = false;
            });
        },
        formatDate(date) {
            const options = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            };

            const formattedDate = new Intl.DateTimeFormat('es-ES', options).format(new Date(date));
            return formattedDate;
        },
        onDocumentList() {
            this.$router.push({ name: 'list' });
        },
        pdfLoaded() {
            this.page = 1;
        },
        error: function (err) {

            console.log(err);
        },
        isPhone() {
            const ua = navigator.userAgent;

            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return true;
            } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                return true;
            }
            return false;
        },
        sendOTP() {
            axios.post('/api/File/SendOTPCode?id=' + this.pdf_id).then(response => {
                if (response.data.Result == "OK") {
                    this.$bvModal.show('sendOTP-success-modal');
                } else {

                    if (response.data.Result == "no phone number") {
                        this.$bvToast.toast(`Por favor, accede con tus credenciales para poder utilizar esta función.`, {
                            title: 'Lo sentimos',
                            variant: 'danger'
                        });
                    }
                    else {

                        this.$bvToast.toast(`Ha ocurrido un error al enviar el código OTP`, {
                            title: 'Lo sentimos',
                            variant: 'danger'
                        });
                    }
                }

            }).catch(function () {
                this.$bvToast.toast(`Ha ocurrido un error al enviar el código OTP`, {
                    title: 'Lo sentimos',
                    variant: 'danger'
                });
            });
        },
        backToList() {
            this.$router.push({ name: 'list' });
        },
        watchRenderPage() {
            let canvas = this.$refs.pdfComponent.getElementsByTagName('canvas')[0];
            setTimeout(() => {

                let width = getComputedStyle(canvas).width;
                let height = getComputedStyle(canvas).height;

                width = parseFloat(width);
                height = parseFloat(height);

                this.pageWidth = width;
                this.pageHeight = height;
                let pageObject = this.pagesSignatures[this.page - 1];

                pageObject.pageWidth = width;
                pageObject.pageHeight = height;

                this.allowSignatures = true; // race condition
            }, 2000);
        },
        getSpeaker(bool) {
            this.allowSpeech = bool;
        },
    }
}
</script>

<style scoped>
.pg_number {
    position: absolute;
    width: 100%;
    top: 5px;
    z-index: 20;
    text-align: center;
}

.viewer {
    position: relative;
    width: 100%;
}

.arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
.arrow:hover {
    cursor: pointer;
}
.arrow.left {
    left: 5px;
    z-index: 20;
}
.arrow.right {
    right: 5px;
    z-index: 20;
}

.info-t {
    font-size: clamp(0.5625rem, 0.4063rem + 0.625vw, 0.875rem);
    color: #2B2B2F;
    font-weight: 700;
}

.info-d {
    position: relative;
    padding: 10px 4px 10px 6px;
    background-color: #ebebec;
    border-radius: 2px;
    font-size: clamp(0.5625rem, 0.4688rem + 0.375vw, 0.75rem);
    font-weight: 500;
}


#signaturePad {
    border: 2px solid #94939761;
    background-image: radial-gradient(#a4a4a452 20%, transparent 20%), radial-gradient(#FAFAFA 20%, transparent 20%);
    background-color: #ffffff;
    background-position: 0 0, 50px 50px;
    background-size: 8px 8px;
    margin-top: 0.8rem;
    border-radius: 8px;
}


.vdr {
    cursor: move;
    border: unset !important;
}

.btn .b-icon.bi {
    margin-right: 5px;
    font-size:1.5rem;
}

#current_page {
    width: 40px;
    margin-left: 3px;
    padding: 0;
    margin-right: 2px;
    text-align: center;
    border: 0.5px solid grey;
}

#canv {
    object-fit: contain;
    position: absolute;
    background-color: transparent;
    max-width: 100%;
    width: 100%;
    width: var(--width);
    height: calc(var(--width) * 0.75);
    border-radius: 5px;
}

.webcam-container {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
}

video {
    background: #222;
    --width: 100%;
    width: var(--width);
    border-radius: 5px;
}

.details-col {
    background-color: #fff;
}

.marginButton {
    margin-top: 3rem;
}

/*stepper*/
.wizard-icon-circle {
    width: 30px !important;
    height: 30px !important;
    font-size: 15px !important;
}

li.active .wizard-icon-circle {
    background-color: #2E344A !important;
}

.wizard-progress-with-circle {
    top: 20px !important;
    margin-left: 5px !important;
}

li.active #step-Enviodeldocumento0,
li.active #step-Recepciondeldocumento1,
li.active #step-Firmadeldocumento2 {
    background: #E92135;
}

.img-thumbnail {
    border-radius: unset !important;
    background-color: #dee2e6 !important;
}

::v-deep .vue-form-wizard .wizard-header {
    padding: unset !important;
}

::v-deep .vue-form-wizard .wizard-tab-content {
    padding: 20px 0;
}

::v-deep .vue-form-wizard .wizard-card-footer {
    padding: unset !important;
    margin-top: 1rem !important;
}

::v-deep .vue-form-wizard.sm .wizard-nav-pills>li.active>a .wizard-icon {
    font-size: 15px;
}

::v-deep .stepTitle {
    font-size: 11px !important;
    padding-top: 0.5rem !important;
    font-weight: 700 !important;
}

.wizard-circle-btn {
    border-radius: 50% !important;
    background-color: #E92135;
    color: #fff;
    border: #E92135;
    width: 30px;
    height: 30px;
}

.sign-image {
    width: 65%;
}

@media only screen and (max-width: 765px) {
    .custom_button_wizard {
        margin-bottom: 2rem;
    }

    .vue-form-wizard .wizard-btn {
        min-width: unset;
    }

    .pdf-container {
        margin: unset;
    }

    .pdf-self {
        width: 100%;
        margin: 0;
        border: 1px solid #8080804f;
    }

    .sign-image {
        width: 28%;
    }
}

/*responsive*/
@media (min-width:768px) and (max-width: 992px) {
    .sign-image {
        width: 30%;
    }
}

@media only screen and (max-width: 1024px) {
    .marginButton {
        margin-top: 0 !important;
    }
}
</style>